module.exports = __webpack_public_path__ + "img/astral_8.994a253d.svg";